var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import alignSelf from "../../../mixins/alignSelf";
import margin from "../../../mixins/margin";
import padding from "../../../mixins/padding";
import round from "../../../mixins/round";
import opacity from "../../../mixins/opacity";
import position from "../../../mixins/position";
import zIndex from "../../../mixins/zIndex";
import cursor from "../../../mixins/cursor";
import height from "../mixins/height";
import width from "../mixins/width";
import overflow from "../mixins/overflow";
import background from "../mixins/background";
import flex from "../mixins/flex";
import wrap from "../mixins/wrap";
import alignItems from "../mixins/alignItems";
import alignContent from "../mixins/alignContent";
import justifyContent from "../mixins/justifyContent";
import gap from "../mixins/gap";
import direction from "../mixins/direction";
import border from "../mixins/border";
var Flex = function (Component) { return styled(Component)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), flex, direction, wrap, alignItems, alignContent, justifyContent, alignSelf, position, margin, padding, gap, width, height, background, opacity, border, round, overflow, zIndex, cursor); };
export default Flex;
var templateObject_1;
